import { useNavigate, useRouter } from '@tanstack/react-router';
import { useRef } from 'react';

// Edit mode lives in the URL, so reloading an editor (or opening a copied link)
// comes back to the editor instead of the read view.
export type EditSearch = { edit?: true };

export function validateEditSearch(
  search: Record<string, unknown>,
): EditSearch {
  return search.edit === true || search.edit === 'true' ? { edit: true } : {};
}

export function useEditMode(editing: boolean) {
  const navigate = useNavigate();
  const router = useRouter();
  // Whether this page opened the editor, or the URL arrived already editing.
  const opened = useRef(false);

  const set = (on: boolean) =>
    navigate({
      to: './',
      search: (prev: Record<string, unknown>) => ({
        ...prev,
        edit: on || undefined,
      }),
      replace: !on,
    });

  return {
    editing,
    // Pushed, so Back closes the editor (asking first if there are unsaved
    // changes).
    startEditing: () => {
      opened.current = true;
      set(true);
    },
    // Undo that entry rather than replacing it: replacing leaves Back pointing
    // at a copy of the page you are already on, which looks like a dead button.
    stopEditing: () => {
      if (opened.current) {
        opened.current = false;
        router.history.back();
        return;
      }
      set(false);
    },
  };
}
